import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  parent_id: '',
  Core_FICS_patient_identifier: '',
  prescreen_id: '',
  sex: '',
  date_of_birth: '',
  cancer_type: '',
  stage: '',
  eligible_trials: '',
  mutation_status: '',
  ECOG_status: '',
  add_to_trial: '',
  isBackButton: false,
  formLibraryDataIsOpen: false,
  formLibraryMainData: null,
  currentPatientTrailTab: '1',
  currentFormData: null,
  assignedFormsPatientTrail: [],
  selectedIntrialPatient: null,
  plannedDate: null,
  activeStep: 0
};

export const selectedIntrialPatientInfo = createSlice({
  name: 'SelectedIntrialPatientInfo',
  initialState,
  reducers: {
    clearIntrialPatientInfo: state => {
      state.parent_id = '';
      state.Core_FICS_patient_identifier = '';
      state.prescreen_id = '';
      state.sex = '';
      state.date_of_birth = '';
      state.cancer_type = '';
      state.stage = '';
      state.eligible_trials = '';
      state.mutation_status = '';
      state.ECOG_status = '';
      state.add_to_trial = '';
      state.isBackButton = false;
    },
    setBackButtonPTN: (state, action: PayloadAction<any>) => {
      state.isBackButton = action.payload;
    },
    setIntrialPatientInfo: (state, action: PayloadAction<any>) => {
      state.parent_id = action.payload.parent_id;
      state.Core_FICS_patient_identifier = action.payload.Core_FICS_patient_identifier;
      state.prescreen_id = action.payload.prescreen_id;
      state.sex = action.payload.sex;
      state.date_of_birth = action.payload.date_of_birth;
      state.cancer_type = action.payload.cancer_type;
      state.stage = action.payload.stage;
      state.eligible_trials = action.payload.eligible_trials;
      state.mutation_status = action.payload.mutation_status;
      state.ECOG_status = action.payload.ECOG_status;
      state.add_to_trial = action.payload.add_to_trial;
    },
    setFormLibraryDataIsOpen: (state, action: PayloadAction<any>) => {
      state.formLibraryDataIsOpen = action.payload;
    },
    setFormLibraryMainData: (state, action: any) => {
      state.formLibraryMainData = action.payload;
    },
    clearFormLibraryMainData: state => {
      state.formLibraryMainData = null;
    },
    setCurrentPatientTrailTab: (state, action: any) => {
      state.currentPatientTrailTab = action.payload;
    },
    clearCurrentPatientTrailTab: state => {
      state.currentPatientTrailTab = '1';
    },
    setCurrentFormData: (state, action: any) => {
      state.currentFormData = action.payload;
    },
    setAssignedFormsPatientTrail: (state, action: any) => {
      state.assignedFormsPatientTrail = action.payload;
    },
    setSelectedIntrialPatient: (state, action: PayloadAction<any>) => {
      state.selectedIntrialPatient = action.payload;
    },
    clearSelectedIntrialPatient: state => {
      state.selectedIntrialPatient = null;
    },
    setPlannedDate: (state, action: PayloadAction<any>) => {
      state.plannedDate = action.payload;
    },
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    }
  }
});

export const {
  clearIntrialPatientInfo,
  setIntrialPatientInfo,
  setFormLibraryDataIsOpen,
  setFormLibraryMainData,
  setCurrentPatientTrailTab,
  setCurrentFormData,
  clearFormLibraryMainData,
  clearCurrentPatientTrailTab,
  setAssignedFormsPatientTrail,
  setSelectedIntrialPatient,
  clearSelectedIntrialPatient,
  setBackButtonPTN,
  setPlannedDate,
  setActiveStep
} = selectedIntrialPatientInfo.actions;
